import useMutationApi from 'src/api/useMutationApi';

interface UpdateCustomerProductBody {
  customerProductId: string;
  customerDescription?: string | null;
  customerMainIdentifier?: string | null;
  customerSku?: string | null;
  customerUpc?: string | null;
  customerPlu?: string | null;
  customerEan?: string | null;
  customerGtin?: string | null;
  customerAsin?: string | null;
  customerMpn?: string | null;
  customerIsbn?: string | null;
  customerNsn?: string | null;
  matchSequence?: number;
}

const useUpdateCustomerProduct = (onSuccess?: () => void) => {
  return useMutationApi<UpdateCustomerProductBody, void>({
    endpoint: 'accounts-receivable/customer-products',
    method: 'PUT',
    options: {
      onSuccess,
    },
    showSuccessToast: true,
  });
};

export default useUpdateCustomerProduct;
